import { css } from 'styled-components';
import token from 'styled-token';
import { buttonResetMixin } from '../buttonResetMixin';
import { iconSizeMixin } from '../iconSizeMixin';

/** @class DropdownIconMixin */
/**
 * Standalone styles for the DropdownIcon component. Expects an Icon component as a child.
 *
 * @example
 * import { DropdownIconMixin, IconMore } from '@zillow/constellation';
 *
 * const Component = styled.button`
 *     ${DropdownIconMixin}
 * `;
 *
 * <Component>
 *     <IconMore />
 * </Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var DropdownIconMixin = function DropdownIconMixin(props) {
  return token({
    iconColor: 'DropdownIcon.iconColor',
    iconSize: 'DropdownIcon.size'
  }, function (_ref) {
    var iconColor = _ref.iconColor,
      iconSize = _ref.iconSize;
    return css(["", " ", " color:", ";"], buttonResetMixin(props), iconSizeMixin(Object.assign({}, props, {
      iconSize: iconSize
    })), iconColor);
  })(props);
};